import { onCanvas } from "../../shared/mouseFunctions";
import AbstractTool from "../AbstractTool";

export default class PlacementTool extends AbstractTool {
    resetPreviousTool = true;
    scrollEnabled = true;
    newElements = [];

    activate(newElements, sticky = false) {
        this.sticky = sticky;
        this.newElements = newElements;
    }

    deactivate() {
        this.newElements = [];
    }

    passArgs(newElements, sticky = false) {
        this.sticky = sticky;
        this.newElements = newElements;
    }

    display() {
        this.p.push();
        this.p.translate(this.view.snappedRelX, this.view.snappedRelY);
        if (onCanvas(this.provider) && this.newElements.length > 0) {
            this.newElements.forEach(element => element.display());
        }
        this.p.pop();
    }

    clickMouseOnCanvas() {
        let newElements = this.newElements.map(element => {
            let newElement = element.clone(this.view.snappedAbsX, this.view.snappedAbsY);
            this.elements.add(newElement);
            return newElement;
        });
        if (!this.sticky && !this.p.keyIsDown(this.p.SHIFT)) {
            this.tools.setTool('select');
            this.sideBar.setTab('info');
            this.selection.select(newElements);
        }
        return false;
    }

    moveMouse() {
        this.cursor.cross();
    }

    getTips() {
        let multiple = this.newElements.length > 1;
        let count = multiple ? this.newElements.length + ' elements' : 'the element';
        let pronoun = multiple ? 'them' : 'it';
        return `Click to place ${count}. Hold SHIFT to place ${pronoun} multiple times.`
    }

    pressKey(code) {
        switch (code) {
            case 27: // Esc
                this.tools.setTool('select');
                return;
            case 37: // left arrow
                this.view.move(this.arrowMove, 0);
                return;
            case 38: // up arrow
                this.view.move(0, this.arrowMove);
                return;
            case 39: // right arrow
                this.view.move(-this.arrowMove, 0);
                return;
            case 40: // down arrow
                this.view.move(0, -this.arrowMove);
                return;
        }
    }
}
